<div class="alert {{alert?.state}} col-md-12" *ngIf="alert?.active  && alert?.pos==pos">
    <div [innerHTML]="alert?.message"></div>
</div>